import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type { ISectionProps, ISectionStateValues } from '../Section.types';

export default withCompController<
  ISectionProps,
  ISectionProps,
  ISectionProps,
  ISectionStateValues
>(({ mapperProps, stateValues }) => {
  const { experiments = {} } = stateValues;
  const isPlayPauseSectionExperimentOn = isExperimentOpen(
    experiments,
    'specs.thunderbolt.playPauseSection',
  );

  return {
    ...mapperProps,
    isPlayPauseSectionExperimentOn,
  };
});
